import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { callApi } from '../../../../../Appy';
import { findLinkT } from '../../../../../LinkyLinky';
import ReactionComponent, { RCProps } from '../../../../../ReactionComponent';
import { FormOutValues } from '../../../../../Resource/FormTemplates/Types';
import { Link } from '../../../../../Resource/Types';
import { licenseAllocationsFormResourceDecoder, submissionResponseDecoder } from './Decoders';
import Store from './Store';
import { State, SubmissionResponse, SubmitError } from './Types';

const getLicenseAllocationsForm = callApi(licenseAllocationsFormResourceDecoder, {});

const submitLicenseAllocations = (values: FormOutValues) =>
  callApi(submissionResponseDecoder, values);

const handleSubmitResponse =
  (store: Store) =>
  (response: SubmissionResponse): void => {
    switch (response.kind) {
      case 'submission-success':
        store.submitted(response.resource);
        break;
      case 'validation-errors':
        store.ready(response.resource);
        break;
      default:
        assertNever(response);
    }
  };

class LicenseAllocationsReactions extends ReactionComponent<Store, State, RCProps<Store>> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        getLicenseAllocationsForm(state.link).fork(store.loadingError, store.ready);
        break;
      case 'loading-error':
        warn('Could not load License Allocations', JSON.stringify(state.error));
        break;
      case 'ready':
        break;
      case 'submitting':
        Task.succeed<SubmitError, ReadonlyArray<Link>>(state.resource.links)
          .andThen(findLinkT(state.template.target))
          .andThen(submitLicenseAllocations(state.values))
          .fork(store.submittingError, handleSubmitResponse(store));
        break;
      case 'submitting-error':
        warn('Could not submit License Allocations', JSON.stringify(state.error));
        break;
      case 'submitted':
        break;
      default:
        assertNever(state);
    }
  };
}

export default LicenseAllocationsReactions;
